module.exports = __webpack_public_path__ + "img/15.c200d4a3.jpg";